const endpoints = {
  hypotheses: {
    kinds: 'api/v2.5/dictionaries/hypotheses/kinds',
    mark_types: 'api/v2.5/dictionaries/hypotheses/mark_types',
    marks: 'api/v2.5/dictionaries/hypotheses/marks',
    priorities: 'api/v2.5/dictionaries/hypotheses/priorities',
    statuses: 'api/v2.5/dictionaries/hypotheses/statuses',
    tools: 'api/v2.5/dictionaries/hypotheses/tools',
    process_statuses: 'api/v2/dictionaries/hypotheses/process_statuses',
    achievement_status: 'api/v2/dictionaries/hypotheses/achievement_status',
    growth_point_id: 'api/v2/dictionaries/hypotheses/growth_point_id',
    mark_type_id: 'api/v2/dictionaries/hypotheses/mark_type_id',
    kind_id: 'api/v2/dictionaries/hypotheses/kind_id',
  },
  common: {
    bill_size: 'api/v2.5/dictionaries/bill_size',
    company_size: 'api/v2.5/dictionaries/company_size',
    customer_goal: 'api/v2.5/dictionaries/customer_goal',
    customer_problem: 'api/v2.5/dictionaries/customer_problem',
    customer_request: 'api/v2.5/dictionaries/customer_request',
    product_type: 'api/v2.5/dictionaries/product_type',
    channels: 'api/v2/channels',
  },
  support: {
    priorities: 'api/v2/dictionaries/issues/priorities',
    categories: 'api/v2/dictionaries/issues/categories',
    statuses: 'api/v2/dictionaries/issues/statuses',
  },
}

export default endpoints
